// extracted by mini-css-extract-plugin
export default {"container":"CostStatistics_container__zjmlt","label":"CostStatistics_label__gEqe0","scrollBox":"CostStatistics_scrollBox__jEc11"};